var _effectorFileName = "/builds/gmini/front-ism-api-sdk/src/HistoryChanges.tsx";
import * as t from 'io-ts';
import { PaginatedList } from './PaginatedList';
export var HistoryChanges;
(function (_HistoryChanges) {
  var Operations = _HistoryChanges.Operations = t.union([t.literal('UPDATED'), t.literal('ADDED'), t.literal('REMOVED')], 'HistoryOperations');
  var CommonItemFields = _HistoryChanges.CommonItemFields = t["interface"]({
    operation: Operations
  }, 'HistoryCommonItemFields');
  var Item = _HistoryChanges.Item = function (field, value) {
    return t.intersection([CommonItemFields, t["interface"]({
      field: field,
      newValue: t.union([value, t["null"]])
    }), t.partial({
      oldValue: t.union([value, t["null"]])
    })], 'HistoryItem');
  };
  var Change = _HistoryChanges.Change = function (item) {
    return t["interface"]({
      version: t.number,
      operation: Operations,
      authorId: t.string,
      date: t.string,
      items: t.array(item)
    }, 'HistoryChange');
  };
  var io = _HistoryChanges.io = function (item) {
    return PaginatedList(Change(item));
  };
})(HistoryChanges || (HistoryChanges = {}));